import {
    useRef,
    useMemo,
    useState,
    useEffect,
    useContext,
    useCallback,
} from "react";
import {
    Callout,
    Spinner,
    IconButton,
    SpinnerSize,
    TooltipHost,
    ThemeProvider,
    DirectionalHint,
} from "@fluentui/react";

import { pdfjs } from "react-pdf";
import _, { set } from "lodash";

import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

import styles from "./XplrrPDFSideByChat.module.css";

import smoothScrollIntoView from "smooth-scroll-into-view-if-needed";

import * as sdk from "microsoft-cognitiveservices-speech-sdk";

import customTheme from "./../../theme/customTheme";

import {
    HiOutlineVolumeUp,
    HiOutlineVolumeOff
} from "react-icons/hi";
import { MdDownloading } from "react-icons/md";
import { HiMiniPlayPause } from "react-icons/hi2";


import {
    fetchSpeechAOI,
    getVoiceVersion,
    prepSsmlDocReader,
    getClearTextForAudio
} from "../../api/aud";


import XplrrBOXPDF from "../XplrrBOXPDF/XplrrBOXPDF";
import PageSelector from "../PageSelector/PageSelector";
import { qReadify } from "../../api";
import FileDropdown from "../FileDropdown/FileDropdown";

import { GlobalContext } from "../../GlobalContext";
import {
    pb_excl,
    assistantCodes,
    emptyValNumObj,
    applyReplacements,
    xplrrContentListFileOrderKey
} from "../../lsts";

import {
    scrollToPageCSTM,
    scrollToPageDefault,
    scrollToPageNoSmooth,
    scrollCustomAnimPage,
    scrollCustomAnimElement,
    reendableUserScrollHandling,
} from "../../scrll_glob";

import {
    wigglePixelV2,
    addDotIfNeeded,
    additionalFixes,
    stopWigglePixel,
    getDesiredWidth,
    filterHighlightString
} from "../../util_glob";

import { prepareHighlightRegexInvIncluded } from "../../rgx_glob";
import {
    gfile,
    gcontentlist,
    highLightItem,
    gXplrrFileOrder,
    gXplrrSpaceOrder,
    gXplrrSpaceIndex,
    gXplrrExtendedFileList,
    gXplrrContentListFileOrder,
    gXplrrCitationChangeCallback
} from "../../interfaces";
import { renderLinkData } from "../XplrrPDF/renderLinkData";
import {
    playButStylesSBS,
    pauseButStylesSBS
} from "../../styles_glob";


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface ViewerPDFProps {
    startPage: string;
    citationFileId: string;
    xplrrCitationChangeCallback: (callBackProps: gXplrrCitationChangeCallback) => void;
    fileId: string;
    refPageNum: string;
    isCitation: boolean;
    rndo?: string;
    searchString: string;
    activeGroupState: string;
    fileList: gfile[];
    shouldPlayAudio: string;
}

const XplrrPDFSideByChat = ({
    startPage,
    citationFileId,
    xplrrCitationChangeCallback,
    fileId,
    refPageNum,
    isCitation,
    rndo,
    searchString,
    activeGroupState,
    fileList,
    shouldPlayAudio
}: ViewerPDFProps) => {
    const { sourceHighlighting, docAudio, selectedGroup } = useContext(GlobalContext);

    const [file, setFile] = useState<gfile>(); // current file
    const [flId, setFlId] = useState<string>();
    const [srcId, setSrcId] = useState<string>(selectedGroup.invoicesgroup == 1 ? "sbs" : "sbs");
    const [audio, setAudio] = useState<HTMLAudioElement | null>(null);
    const [fileMap, setFileMap] = useState<gXplrrSpaceOrder>({});                                       // full file ⇒ item map
    const [numPages, setNumPages] = useState<number>();                                                 // number of doc pages
    const [isPlaying, setIsPlaying] = useState<boolean>(false);
    const [audioPage, setAudioPage] = useState<number>(0);
    const [pageLoaded, setPageLoaded] = useState<boolean>(true);
    const [panelWidth, setPanelWidth] = useState<number>(500);                                          // initial width for datapanels
    const [isResizing, setIsResizing] = useState<boolean>(false);
    const [docRendered, setDocRendered] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [activeFileId, setActiveFileId] = useState<string>();
    const [manualSection, setManualSecton] = useState<number>();
    const [referencePage, setReferencePage] = useState<number>(0);
    const [isLoadingAudio, setIsLoadingAudio] = useState(false);
    const [panelWidthRight, setPanelWidthRight] = useState(window.innerWidth * 0.55);                   // initial width for pdf -align with pdfViewC in xplrrpdfsidebysidechat css
    const [contentFileOrder, setContentFileOrder] = useState<gXplrrContentListFileOrder>({});
    const [fileListStateVar, setFileListStateVar] = useState<gfile[]>([]);
    const [activeCitationState, setActiveCitationState] = useState<string>();
    const [isContentTableShowing, setIsContentTableShowing] = useState<boolean>(false);                 // files to showcase
    const [resizeBackTriggerCount, setResizeBackTriggerCount] = useState<number>(0);
    const [contentRefreshTriggerIncrement, setContentRefreshTriggerIncrement] = useState(0);
    const [perFilesPerSectionStateMap, setPerFilesPerSectionStateMap] = useState<Map<string, Map<string, boolean>>>(new Map());

    const eclientx = useRef<number>(0);
    const audioRef = useRef<sdk.SpeakerAudioDestination | null>(null);
    const leftResizing = useRef<number>(0);
    const synthesizerRef = useRef<sdk.SpeechSynthesizer | null>(null);


    useEffect(() => {
        // prevent runs before the space has aligned
        if (activeGroupState != selectedGroup.selectionId) return;
        if (fileList.length == 0) return;
        setActiveCitationState(citationFileId);

        if (fileId != flId || fileId != activeFileId) {
            window.globalBase64String = "";
            window.globalPDFPageDimensions = [];

            setFlId(fileId);
            setActiveCitationState(citationFileId);

            const fileToLoad = fileList.find(f => f.fileid == fileId);
            setActiveFileId(fileId);
            setFile(fileToLoad);

            setCurrentPage(parseInt(startPage));
            setReferencePage(parseInt(startPage));
        } else {
            setReferencePage(parseInt(startPage));
            setHighlightsPerfAfterLoad();
        }
    }, [rndo]);

    useEffect(() => {
        if (activeGroupState != selectedGroup.selectionId) return;
        if (fileList.length == 0) return;
        if (activeCitationState && fileId == flId && activeFileId == flId) setHighlightsMain();

        const fileMap: gXplrrSpaceOrder = fileMapGen(fileList);                                     // generate content list file order and item opened map
        const cachedFileOrder: gXplrrContentListFileOrder = setContentFileOrderToState(fileList);   // order items, based on local state cache or default
        const extendedFileList: gXplrrExtendedFileList[] = fileList.map((flfile, flIndex) => {
            return {
                ...flfile,
                globalXplrrOrder: cachedFileOrder[flfile.fileid] == null ? fileMap[parseInt(flfile.fileid)].order : cachedFileOrder[flfile.fileid]
            };
        });
        setFileMap(fileMap); // preprocess - need data for dynamic content list
        setFileListStateVar(extendedFileList.sort((a, b) => a.globalXplrrOrder - b.globalXplrrOrder));
    }, [activeFileId]);

    useEffect(() => {
        if (activeGroupState != selectedGroup.selectionId) return;
        if (fileList.length == 0) return;

        // preserve file order to local cache
        if (Object.keys(contentFileOrder).length > 0) {
            const fileOrderCache = localStorage.getItem(xplrrContentListFileOrderKey);
            if (fileOrderCache) {
                const fullFileOrderCacheParsed: gXplrrSpaceIndex = JSON.parse(fileOrderCache);
                fullFileOrderCacheParsed[selectedGroup.selectionId] = contentFileOrder;
                localStorage.setItem(xplrrContentListFileOrderKey, JSON.stringify(fullFileOrderCacheParsed));
            } else {
                const fullFileOrderCache: gXplrrSpaceIndex = {};
                fullFileOrderCache[selectedGroup.selectionId] = contentFileOrder;
                localStorage.setItem(xplrrContentListFileOrderKey, JSON.stringify(fullFileOrderCache));
            }
        }
    }, [contentFileOrder]);

    useEffect(() => {
        stopSpeech();
    }, [shouldPlayAudio]);

    useEffect(() => {
        setContentRefreshTriggerIncrement(prevValue => prevValue + 1);
    }, [perFilesPerSectionStateMap]);

    useEffect(() => {
        setSrcId(selectedGroup.invoicesgroup == 1 ? "sbs" : "sbs");
    }, [selectedGroup.invoicesgroup]);

    // pdf page numbers - handle current page number state
    const handleScroll = (pageNumCur: number) => {
        if (pageNumCur != currentPage) setCurrentPage(pageNumCur);
    };

    // highlights - set highlights on activefile change and on load time callback from pdfbox
    const setHighlightsMain = async () => {
        if (!searchString) {
            // nav req without highlights
            setCurrentPage(parseInt(startPage));
            scrollCustomAnimPage(parseInt(startPage), currentPage);
            return;
        }
        if (activeCitationState && isCitation && sourceHighlighting == true) applyHighlightsPerf();
        removeFontColorToMatchesRed();
        const allResults = await applyHighlightMatches();
        const allResultsNull = allResults?.every(result => result === null);
        if (allResultsNull) if (startPage) scrollToPageNoSmooth(parseInt(startPage), '‹hl_main›');
        reendableUserScrollHandling('‹hl_main›', 100);
        stopWigglePixel("‹wiggle_pixel_sbs›");
    };

    // highlights - set highlights after load (triggered by rndo useeffect)
    const setHighlightsPerfAfterLoad = useCallback(async () => {
        if (!searchString) {
            // nav req without highlights
            setCurrentPage(parseInt(startPage));
            scrollCustomAnimPage(parseInt(startPage), currentPage);
            return;
        }

        removeFontColorToMatchesRed();
        if (activeCitationState && sourceHighlighting == true) applyHighlightsPerf();

        const allResults = await applyHighlightMatches();
        const allResultsNull = allResults?.every(result => result === null);
        if (allResultsNull) {
            if (startPage) {
                scrollToPageNoSmooth(parseInt(startPage), '‹hal_aft›');
                reendableUserScrollHandling('‹hal_aft›');
            }
        }
        setPageLoaded(true);
    }, [searchString, startPage, activeCitationState, sourceHighlighting]);

    // highlights - find highlights - from setHighlightsV3  or after from applyHighlightMatches
    const findMatchingSequenceRGX = async (pg: number[]) => {
        const filteredTargetString = filterHighlightString(searchString);
        let rgx = prepareHighlightRegexInvIncluded(filteredTargetString, selectedGroup.assistanttype);

        const selectorPG = pg.map(pg => `.pdf_itm_${pg - 1}`).join(", ");
        const items = document.querySelectorAll(selectorPG);
        const itemsArray = Array.from(items);

        let processedText = "";
        let elementMap: highLightItem[] = [];

        for (let index = 0; index < itemsArray.length; index++) {
            const item = itemsArray[index] as HTMLElement;
            const originalItemText = item.textContent?.trim();
            const itemText = filterHighlightString(originalItemText);
            if (itemText.length > 0) {
                elementMap.push({
                    startIndex: processedText.length,
                    endIndex: processedText.length + itemText.length - 1,
                    element: item as HTMLElement,
                    processedText: itemText
                });
                processedText += itemText;
            }
        }
        let matches = [...processedText.matchAll(rgx)];
        if (selectedGroup.assistanttype == assistantCodes.ipa) {
            matches = matches.filter(
                match =>
                    (match && match.length < 2 && match[0].length <= searchString.length) ||
                    (match && match.length > 1 && match[1].length <= searchString.length)
            );
        }
        matches.forEach(match => {
            let startIndex = match.index || 0;
            const endIndex = startIndex + match[0].length - 1;

            const matchingElements = elementMap.filter(
                item =>
                    (item.startIndex <= startIndex && startIndex <= item.endIndex) ||
                    (item.startIndex <= endIndex && endIndex <= item.endIndex) ||
                    (startIndex <= item.startIndex && item.endIndex <= endIndex)
            );
            matchingElements.forEach((item, index) => {
                if (index == matchingElements.length - 1) {
                    if (window.globalHiglightFound == true) {
                        import.meta.env.DEV === true && console.log("glbalHglghtFnd_not_true", window.globalHiglightFound);
                    } else {
                        window.globalHiglightFound = true;
                        window.globalWigglePixel = 0; // addednow
                        try {
                            let itmPg = parseInt(item.element.id.split("_")[1]);
                            let skndEl = item.element;
                            if (index > 0 && skndEl.innerText.length < 5) skndEl = matchingElements[index - 1].element;

                            scrollCustomAnimElement(itmPg, skndEl, skndEl, currentPage);
                        } catch {
                            smoothScrollIntoView(item.element as HTMLElement, { behavior: "smooth", block: "center" });
                        }
                    }
                }
                if (numPages && numPages > 1) item.element.classList.add(styles.citHglghtrRed);
            });
        });
        if (matches.length > 0 && matches[0].index !== undefined) {
            return { startIndex: matches[0].index, endIndex: matches[0].index + matches[0][0].length - 1 };
        } else {
            return null;
        }
    };

    // highlights - main workhorse for applying highlights
    const applyHighlightMatches = async () => {
        if (file?.indexchunks) {
            let highlightPages: number[] = findRange([...file.indexchunks, file.pagedimensions.length], parseInt(startPage));
            if (highlightPages.length > 0 && highlightPages[0] > 1) highlightPages = [highlightPages[0] - 1].concat(highlightPages); // add one more pages infront. need to deep dive in index/number logic
            window.globalHiglightFound = false;
            wigglePixelV2(highlightPages[0], currentPage);
            const promises = highlightPages.map((page, index) => setHighlightsV3(page, index, highlightPages.length));
            const results = await Promise.all(promises);
            const allResultsNull = results?.every(result => result === null);
            if (allResultsNull) {
                const results = await findMatchingSequenceRGX(highlightPages);
                return [results];
            } else {
                return results;
            }
        }
    };

    // highlights - wait for pdf pages to load to start highlight apply
    const waitForAllPDFItems = async (index: number, maxAttempts: number = 50): Promise<true | null> => {
        const isReactPdfPageTextRendererDone = (index: number): boolean => {
            let itemProgress = window.globalItemCounts?.get(index);
            if (itemProgress !== undefined && itemProgress.flag == true) {
                let pdfPageItemCount = document.querySelectorAll(`.pdf_itm_${index}`);
                if (pdfPageItemCount.length == itemProgress.count) {
                    return true;
                } else {
                    setReferencePage(index + 1);
                    return false;
                }
            } else {
                return false;
            }
        };
        for (let attempt = 0; attempt < maxAttempts; attempt++) {
            if (isReactPdfPageTextRendererDone(index)) return true;
            await new Promise(resolve => setTimeout(resolve, 50));
        }

        console.warn(`‹ovr_wait› ${index} after ${maxAttempts} attempts`);
        return null;
    };

    // highlights - apply highlights logic from applyHighlightMatches
    const setHighlightsV3 = async (page: number, i: number, lignth: number) => {
        await waitForAllPDFItems(page - 1, 50);
        if (window.globalHiglightFound == false) {
            if (i == lignth - 1) {
                const difBetweenSrcAndTrgPage = currentPage - page;
                if (Math.abs(difBetweenSrcAndTrgPage) > 5) {
                    if (difBetweenSrcAndTrgPage < 0) {
                        scrollToPageCSTM(currentPage + 1);
                    } else {
                        scrollToPageCSTM(currentPage - 1);
                    }
                }
            }
        }
        const result = await findMatchingSequenceRGX([page]);
        return result;
    };


    const findRange = (numbers: number[], target: number): number[] => {
        numbers.sort((a: number, b: number) => a - b);

        let startIndex = numbers.findIndex((num: number) => num > target);
        let upper = startIndex === -1 ? numbers[numbers.length - 1] : numbers[startIndex];
        let endIndex = numbers.lastIndexOf(target);
        let lower = endIndex !== -1 ? numbers[endIndex] : numbers[startIndex - 1];

        if (lower === undefined || upper === undefined) return []; // return an empty array if target is out of the provided range

        let result = [];

        for (let i = lower; i <= upper; i++) result.push(i);

        if (target === upper) result.push(upper);

        try {
            window.globalpdfObservableRange = result.length;
        } catch {}
        return result;
    }

    const removeFontColorToMatchesRed = (): void => {
        const elements = document.getElementsByClassName(styles.citHglghtrRed);
        while (elements.length > 0) {
            elements[0].classList.remove(styles.citHglghtrRed);
        }
    };



    // content table related
    const setContentFileOrderToState = (fileList: gfile[]) => {
        const fileOrderCache = localStorage.getItem(xplrrContentListFileOrderKey);
        if (fileOrderCache) {
            const fullFileOrderCacheParsed: gXplrrSpaceIndex = JSON.parse(fileOrderCache);
            const fileOrderCacheParsed: gXplrrContentListFileOrder = fullFileOrderCacheParsed[selectedGroup.selectionId];

            if (fileOrderCacheParsed && Object.keys(fileOrderCacheParsed)?.length > 0) {
                setContentFileOrder(fileOrderCacheParsed);
                return fileOrderCacheParsed;
            } else {
                const defaultOrder = getDefaultFileOrderFromCache(fileList);
                setContentFileOrder(defaultOrder);
                return defaultOrder;
            }

        } else {
            const defaultOrder = getDefaultFileOrderFromCache(fileList);
            setContentFileOrder(defaultOrder);
            return defaultOrder;
        }
    };

    // content table related
    const getDefaultFileOrderFromCache = (fileList: gfile[]) => {
        const defaultOrder: gXplrrContentListFileOrder = {};
        fileList.map((flfile, flIndex) => {
            defaultOrder[flfile.fileid] = flIndex;
        });
        return defaultOrder;
    };


    // content table related
    const fileMapGen = (fileList: gfile[]) => {
        let fileMap: gXplrrSpaceOrder = {};
        fileList.map((flfile, flIndex) => {
            let arrItems: gXplrrFileOrder = {
                order: flIndex,
                opened: false,
                fileItemOrder: {}
            };
            if (flfile.contentlist && flfile.contentlist.length > 0) {
                flfile.contentlist.forEach((flItem, flItemIndex) => {
                    const { currentValue, splitValues, splitLength, itemLevel, pageNumExtracted } = contentListValueNumbering(flItem);
                    arrItems.fileItemOrder[flItemIndex] = {
                        opened: false,
                        currentValue: currentValue,
                        splitValues: splitValues,
                        splitLength: splitLength,
                        itemLevel: itemLevel,
                        pageNumExtracted: pageNumExtracted
                    };
                });
            }

            fileMap[parseInt(flfile.fileid)] = arrItems;
        });
        return fileMap;
    };

    const setPages = (numP: number): void => {
        setNumPages(numP);

        window.globalTextArray = [];
        window.globalTextArrayAudio = [];
        window.globalTextMap = new Map<string, boolean>();
        window.globalPDFExtr = [];
        window.globalPDFPageMap = new Map<number, any>();
        window.globalPDFContent = [];
        window.globalAllNessesaryPDFPagesLoaded = false;
        window.globalPDFPageDimensions = [];
    };



    const applyHighlightsPerf = () => {
        if (file?.indexchunks) {
            let highlightPages: number[] = findRange([...file.indexchunks, file.pagedimensions.length], parseInt(startPage));
            for (let i = 0; i < highlightPages.length; i++) {
                document.querySelectorAll(`div[data-page-number="${highlightPages[i]}"] span`).forEach(span => {
                    (span as HTMLElement).classList.add(styles.citHglghtr);
                });
            }
        }
    };

    // callback when pdf load ready
    const handleTimeout = () => {
        reendableUserScrollHandling('‹hndl_tout›');
        setDocRendered(true);
        if (fileId == activeFileId) setHighlightsMain();
        setPageLoaded(true);
    };

    const setContentList = (contentList: { title: string; dest: number }[]) => {
        import.meta.env.DEV === true && console.log("VWRPDF¦setContentList", contentList);
    };

    function contentListValueNumbering(item: gcontentlist) {
        const currentValue = item.destPageNum;
        if (item.srcText) {
            let splitValues = item.srcText.trim().replace(" .", ".").split(" ");
            let pageNum = item.destPageNum;
            if (!isNaN(Number(splitValues[splitValues.length - 1]))) {
                pageNum = parseInt(splitValues[splitValues.length - 1]);
                splitValues.pop();
            }
            if (!splitValues || splitValues.length == 0) {
                return emptyValNumObj;
            }
            return {
                currentValue: currentValue.toString(),
                splitValues: splitValues,
                splitLength: splitValues.length,
                itemLevel: (addDotIfNeeded(splitValues[0]).match(/\./g) || []).length - 1,
                pageNumExtracted: pageNum
            };
        } else {
            return emptyValNumObj;
        }
    }

    const handlePageChangeFromPageSelector = (event: React.ChangeEvent<HTMLSelectElement>) => {
        window.globalUserScrollLazyLoadEnabled == true;
        setManualSecton(Number(event.target.value));
        setCurrentPage(Number(event.target.value));
        scrollToPageNoSmooth(Number(event.target.value), '‹hndl_pg_chg›');
        reendableUserScrollHandling('‹hndl_pg_chg›');
    };

    const handleClick = (target: EventTarget, item: gcontentlist, indx: number) => {
        scrollToPageNoSmooth(item.destPageNum, '‹hndl_cl›');
        setCurrentPage(item.destPageNum);
        reendableUserScrollHandling('‹hndl_cl›');
    };

    const handleFileClick = (target: EventTarget, fl: gfile, flIndex: number) => {
        window.globalUserScrollLazyLoadEnabled == true;
        setFile(fl);
        setActiveFileId(fl.fileid);
        setCurrentPage(1);
        reendableUserScrollHandling('‹fl_clk›', 100);
    };

    const expandCollapseSection = (flId: string, srcText: string) => {
        setPerFilesPerSectionStateMap(prevMap => {
            const newMap = new Map(prevMap);
            const fileMap = newMap.get(flId) || new Map();
            const newFileMap = new Map(fileMap);

            newFileMap.set(srcText, !fileMap.get(srcText));
            newMap.set(flId, newFileMap);

            return newMap;
        });
    };

    const playSpeech = () => {
        if (audioRef.current && audioPage == currentPage) {
            audioRef.current.resume();
            setIsPlaying(true);
        } else {
            audioRef.current = null;
            setIsLoadingAudio(true);
            fetchSpeechAudio(currentPage);
        }
    };

    const stopSpeech = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            setIsPlaying(false);
        }
    };

    const handleAudioAOI = async (page: number, retryCount = 0) => {
        setCurrentPage(page);
        let text = getClearTextForAudio(page);
        if (text && text.trim().length > 0) {
            let aud = await fetchSpeechAOI(text);
            if (aud) {
                aud.loop = false;
                aud.onended = () => {
                    if (numPages && page + 1 < numPages) {
                        scrollToPageDefault(page + 1);
                        handleAudioAOI(page + 1);
                    }
                };
                setAudio(aud);
                aud.play();
                setIsLoadingAudio(false);
                setIsPlaying(true);
            }
        } else {
            if (numPages && currentPage < numPages) {
                scrollToPageDefault(page + 1);
                handleAudioAOI(page + 1);
            }
        }
    };

    // audio - advance current page
    const setCurrentPageFunc = (page: number) => {
        setCurrentPage(page);
        window.globalCurrentPage = page;
    };

    const fetchSpeechAudio = async (page: number, retryCount = 0) => {
        const reg = import.meta.env.VITE_STT_R;
        const apk = import.meta.env.VITE_STT_K;

        setCurrentPage(page);
        setAudioPage(page);

        const items = document.querySelectorAll(`.pdf_itm_${page - 1}`);
        let text = Array.from(items)
            .filter(
                item =>
                    item.textContent != null &&                                 // exclude if string is empty
                    !pb_excl.includes(item.textContent.toLowerCase().trim()) && // exclude if string is in the exclusion array
                    item.textContent.trim() !== "|"
            )
            .map(item => item.textContent)
            .join(" ");

        let readify = await qReadify(text, selectedGroup);
        text = applyReplacements(readify);
        text = additionalFixes(text);

        if (text && text.trim().length > 0) {
            try {
                let player = new sdk.SpeakerAudioDestination();

                player.onAudioEnd = function (_) {
                    if (numPages && page + 1 < numPages) {
                        scrollToPageDefault(page + 1);
                        player.close();
                        fetchSpeechAudio(page + 1);
                    }
                };

                player.onAudioStart = function (_) {
                    import.meta.env.DEV === true && console.log("‹sbs_aud_start_xplrr_pdf›");
                };

                let voiceVer = getVoiceVersion(text, selectedGroup.convolang);
                let voiceP = voiceVer.voice;
                let lcle = voiceVer.language;

                audioRef.current = player;
                var audioConfig = sdk.AudioConfig.fromSpeakerOutput(player);
                const speechConfig = sdk.SpeechConfig.fromSubscription(apk, reg);
                speechConfig.speechSynthesisVoiceName = voiceP;

                const synthesizer = new sdk.SpeechSynthesizer(speechConfig, audioConfig);

                synthesizer.synthesisCompleted = (sender, event) => {
                    import.meta.env.DEV === true && console.log("synth_sbs_cmplt_xplrrr_pdf");
                };

                synthesizer.synthesizing = (sender, event) => {
                    import.meta.env.DEV === true && console.log("synth_sbs_synthesizing_xplrrr_pdf");
                };

                synthesizerRef.current = synthesizer;

                setIsPlaying(true);

                synthesizer.speakSsmlAsync(
                    prepSsmlDocReader(text, voiceP, lcle),
                    result => {
                        if (result.reason === sdk.ResultReason.SynthesizingAudioCompleted) {
                            setIsLoadingAudio(false);
                            synthesizer.close();
                        } else {
                            setIsLoadingAudio(false);
                            synthesizer.close();
                        }
                    },
                    error => {
                        console.error("Error: ", error);
                        setIsPlaying(false);
                        synthesizer.close();
                    }
                );
            } catch (error: any) {
                console.error("‹errr_sbs_fetch_speech›", error);
            }
        } else {
            if (numPages && currentPage < numPages) {
                scrollToPageDefault(page + 1);
                fetchSpeechAudio(page + 1);
            }
        }
    };
    const callBackVisibleEntries = (visibleEntries: number[]) => {};

    const callBackIsLoading = (isLoading: boolean) => {
        import.meta.env.DEV === true && console.log("callBackIsLoading¦", currentPage);
    };

    const onContentShow = (fl: gfile | undefined, flIndex: number | undefined) => {
        setIsContentTableShowing(true);
    };

    const resizeTriggerBack = (newWidth: number) => {
        console.log("‹resizeTriggerBack›", newWidth);
        const newWidthActual = window.innerWidth * 0.45;
        const widthRight = window.innerWidth * 0.55;

        setPanelWidth(newWidthActual);
        setPanelWidthRight(widthRight);
        setResizeBackTriggerCount(prevCount => prevCount + 1);
    };
    const setStructureSideBar = (isOpen: boolean) => {};

    return (
        <ThemeProvider theme={customTheme}>
            <div className={styles.exaWrapSBS}>
                {/* title, page selector, speak */}

                <div className={styles.headerFileDropdown}>
                    <FileDropdown
                        file={file}
                        fileListStateVar={fileListStateVar}
                        handleFileClick={handleFileClick}
                        onContentShow={onContentShow}
                        activeFileId={activeFileId}
                        isStructureSideBarOpen={false}
                        setStructureSideBar={setStructureSideBar}
                        hasExtraData={false}
                        groupType={selectedGroup.assistanttype}
                    />
                </div>

                {isContentTableShowing && (
                    <Callout
                        target={"#pdfTtldrpTrg"}
                        className={styles.fileListCallout}
                        onDismiss={() => setIsContentTableShowing(false)}
                        directionalHint={DirectionalHint.bottomLeftEdge}
                        isBeakVisible={false}
                    >
                        <div className={styles.cntntf}>
                            {renderLinkData({
                                file,
                                fileMap,
                                activeFileId,
                                currentPage,
                                referencePage,
                                styles,
                                handleClick,
                                expandCollapseSection,
                                perFilesPerSectionStateMap
                            })}
                        </div>
                    </Callout>
                )}

                {docAudio && (
                    <div className={styles.volButsContainer}>
                        <div className={styles.volButs}>
                            {/* speak button */}

                            <IconButton
                                onClick={() => (isPlaying ? stopSpeech() : playSpeech())}
                                disabled={pageLoaded == true ? false : true}
                                styles={isPlaying || isLoadingAudio ? pauseButStylesSBS : playButStylesSBS}
                                className={selectedGroup.enabledocaudio == 1 ? styles.speakButShow : styles.speakButHide}
                            >
                                {isPlaying ? (
                                    <HiOutlineVolumeOff size={35} />
                                ) : isLoadingAudio ? (
                                    <MdDownloading size={35} />
                                ) : audioRef.current && audioPage == currentPage ? (
                                    <HiMiniPlayPause size={35} />
                                ) : (
                                    <HiOutlineVolumeUp size={35} />
                                )}
                            </IconButton>

                        </div>
                    </div>
                )}
                {/* PAGE SELECTOR */}
                <div className={styles.pageSelectorXplrr}>
                    <div className={styles.pageSelectorOnly}>
                        <PageSelector
                            currentPage={currentPage}
                            numPages={numPages ? numPages : 0}
                            handlePageChange={handlePageChangeFromPageSelector}
                        ></PageSelector>
                    </div>
                    <div className={styles.totPagesDisplay}>/ {numPages}</div>
                </div>
                <div className={styles.pdfWrapXplrr} id="pdfWrapXplrrIDENT">
                    <div className={styles.pdfViewC}>
                        <XplrrBOXPDF
                            file={file}
                            startPage={referencePage}
                            activeFileId={activeFileId ? activeFileId : ""}
                            handleTimeout={handleTimeout}
                            handleScroll={handleScroll}
                            setPages={setPages}
                            setContentList={setContentList}
                            callBackVisibleEntries={callBackVisibleEntries}
                            callBackIsLoading={callBackIsLoading}
                            srcLoc={srcId}
                            companyId={selectedGroup.companyid}
                            panelWidthRight={panelWidthRight}
                            resizeTriggerBack={resizeTriggerBack}
                            isResizing={isResizing}
                            parentClassName={styles.pdfWrapXplrr}
                        ></XplrrBOXPDF>
                    </div>
                </div>
            </div>
        </ThemeProvider>
    );
};

export default XplrrPDFSideByChat;
